<div id="app-wrapper">
    <router-outlet></router-outlet>
    <app-toast-container aria-live="polite" aria-atomic="true"></app-toast-container>
</div>